import ContractActionTypes from "./contract.types";

// const INITIAL_STATE = { userId: null, username: null };
const INITIAL_STATE = {
  contractsList: [],
  selectedContract: {},
  payment_terms: [],
  brand_details: [],
};

const contractReducer = (state = INITIAL_STATE, action) => {
  // console.log(action);
  switch (action.type) {
    case ContractActionTypes.RETRIEVE_CONTRACTS:
      return { ...state, ...action.payload };
    case ContractActionTypes.RETRIEVE_CONTRACT_DETAILS:
      return {
        ...state,
        ...{
          selectedContract: { ...state.selectedContract, ...action.payload },
        },
      };
    case ContractActionTypes.PAYMENT_TERMS:
      return {
        ...state,
        payment_terms: action.payload,
      };
    case ContractActionTypes.BRAND_DETAILS:
      return {
        ...state,
        brand_details: action.payload,
      };
    default:
      return state;
  }
};

export default contractReducer;
